import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/anton/400.css";
import "@fontsource/sedgwick-ave-display/400.css";
import "@fontsource/caveat-brush/400.css";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/space-mono/400.css";
import "@fontsource/space-mono/700.css";
import "@/index.css";
import App from "@/App";

document.querySelectorAll("[data-static-seo]").forEach((n) => n.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
